cockpitApp.directive('groupBookingInfo', function() {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/sections/group-booking-info'
  };
});
